import React from 'react';
import { useIntl } from 'react-intl';

type TProps = {
  rows: number;
  message: string;
  setMessage(message: string): void;
  setRows(rows: number): void;
  onSubmit(): void;
  disabled: boolean;
};

const ChatInputTextarea: React.FC<TProps> = ({
  message,
  rows,
  setRows,
  setMessage,
  onSubmit,
  disabled,
}) => {
  const { formatMessage } = useIntl();
  const textareaLineHeight = 20;
  const minRows = 1;
  const maxRows = 6;

  const onKeyDown = (e: any) => {
    if (e.key === 'Enter' && e.shiftKey) {
      return;
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit();
    }
  };

  const onTextareaChange = (e: any) => {
    setMessage(e.currentTarget.value);
    const previousRows = e.target.rows;
    e.target.rows = minRows;
    const currentRows = ~~(e.target.scrollHeight / textareaLineHeight);
    if (currentRows === previousRows) {
      e.target.rows = currentRows;
    }
    if (currentRows >= maxRows) {
      e.target.rows = maxRows;
      e.target.scrollTop = e.target.scrollHeight;
    }
    setRows(currentRows < maxRows ? currentRows : maxRows);
  };

  return (
    <textarea
      rows={rows}
      placeholder={!disabled ? formatMessage({ id: 'chat.input_placeholder' }) : ''}
      value={message}
      onChange={onTextareaChange}
      onKeyDown={onKeyDown}
      style={{ lineHeight: `${textareaLineHeight}px` }}
      disabled={disabled}
    />
  );
};

export default ChatInputTextarea;
